import { AbstractControl } from '@angular/forms';

export function PhoneNumberZeroesValidator(control: AbstractControl) {
  let value = control.value;

  if (value === null || value === undefined || value.length === 0) {
    return null;
  }

  if (value.length === 11) {
    let ts = value.toString().slice(2);
    let number = parseInt(ts);

    if (!isNaN(number) && number === 0) {
      return { phoneZeroesValid: true };
    }
  }

  return null;
}
